import React from 'react'
import { ImageBackground, StyleSheet, View, ScrollView, Pressable } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import image from '../../../assets/Admin/pokerpower-watermark.png'
import { useRemoteConfig } from '../../../module/remote-config/useRemoteConfig'
import JSONTree from 'react-native-json-tree'
import { useRouter } from 'expo-router'
import { DS } from '@/design-system'
import { AntDesign } from '@expo/vector-icons'

const theme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633'
}

const startStyles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column'
  },
  image: {
    // flex: 1,
    resizeMode: 'cover',
    justifyContent: 'center'
  },
  text: {
    color: 'white',
    fontSize: 42,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#000000a0'
  }
})

export const AdminFeatureFlagScreen = () => {
  const flags = useRemoteConfig()
  const router = useRouter()

  return (
    <ImageBackground resizeMode="cover" source={image} style={{ flexGrow: 1 }}>
      <SafeAreaView style={{ flexGrow: 1 }}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 16 }}>
          <View style={{ flexDirection: 'row', gap: 8, justifyContent: 'center' }}>
            <AntDesign name="flag" size={24} color="black" />
            <DS.Text variant="Heading 3/Regular">Feature Flags</DS.Text>
          </View>
          <Pressable onPress={() => router.back()} hitSlop={10}>
            <AntDesign name="close" size={24} color="black" />
          </Pressable>
        </View>

        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            marginTop: 16,
            opacity: 0.8,
            paddingHorizontal: 16
          }}
        >
          <JSONTree hideRoot data={flags} theme={theme} />
        </ScrollView>
      </SafeAreaView>
    </ImageBackground>
  )
}
